import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

import { useGetContractDetails } from '@/modules/workforce/Contracts/apiHooks';
import ContractGeneralInformation from '@/modules/workforce/Contracts/components/Details/General';
import ContractDetailsHeader from '@/modules/workforce/Contracts/components/Details/Header';
import UnitsTable from '@/modules/workforce/Contracts/components/Details/Table';
import routes from '@/shared/constant/routes';
import { useStore } from '@/shared/hooks/context/createGenericContext';

export default function ContractDetails() {
  const { query, push } = useRouter();

  const [selectedAsset] = useStore((store) => store?.asset);

  const { data } = useGetContractDetails({
    entityId: selectedAsset?.id,
    supplierAssignmentId: query?.id ? Number(query.id) : undefined,
  });

  useEffect(() => {
    if (!query?.id) push(routes.contracts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return data ? (
    <div className='flex flex-col gap-24'>
      <ContractDetailsHeader contract={data} />
      <ContractGeneralInformation contract={data} />
      {data.dailyWage === 0 && data.pricingUnits && (
        <div className=' mt-16'>
          <UnitsTable units={data.pricingUnits} />
        </div>
      )}
    </div>
  ) : null;
}
